<template>
  <el-dialog :title="$t('productGroupManage.addProduct')" :visible.sync="dialogVisible" width="70%"
    @close="handleClose">
    <el-form ref="form" :model="addProductGroupInfo" label-width="120px">
      <el-form-item :label="$t('productGroupManage.selectProduct')">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-select v-model="addProductGroupInfo.categoryId" :placeholder="$t('productGroupManage.selectCategory')"
              style="width:100%" @change="_changeAddProductCatalorys">
              <el-option disabled :value="''" :label="$t('productGroupManage.selectCategory')" />
              <el-option v-for="item in addProductGroupInfo.productCategorys" :key="item.categoryId"
                :label="item.categoryName" :value="item.categoryId" />
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select v-model="addProductGroupInfo.productId" :placeholder="$t('productGroupManage.selectProduct')"
              style="width:100%" @change="_changeAddProduct">
              <el-option disabled :value="''" :label="$t('productGroupManage.selectProduct')" />
              <el-option v-for="item in addProductGroupInfo.products" :key="item.productId" :label="item.prodName"
                :value="item.productId" />
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select v-model="addProductGroupInfo.valueId" :placeholder="$t('productGroupManage.selectSpec')"
              style="width:100%">
              <el-option disabled :value="''" :label="$t('productGroupManage.selectSpec')" />
              <el-option v-for="value in addProductGroupInfo.values" :key="value.valueId"
                :label="value.specName" :value="value.valueId" />
            </el-select>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item :label="$t('productGroupManage.productDesc')">
        <el-input v-model="addProductGroupInfo.prodDesc" type="textarea"
          :placeholder="$t('productGroupManage.productDescRequired')" />
      </el-form-item>

      <el-form-item :label="$t('productGroupManage.groupPeople')">
        <el-input v-model="addProductGroupInfo.userCount" type="number"
          :placeholder="$t('productGroupManage.groupPeopleRequired')" />
      </el-form-item>

      <el-form-item :label="$t('productGroupManage.groupPrice')">
        <el-input v-model="addProductGroupInfo.groupPrice" :placeholder="$t('productGroupManage.groupPriceRequired')" />
      </el-form-item>

      <el-form-item :label="$t('productGroupManage.status')">
        <el-select v-model="addProductGroupInfo.state" :placeholder="$t('productGroupManage.statusRequired')"
          style="width:100%">
          <el-option disabled :value="''" :label="$t('productGroupManage.statusRequired')" />
          <el-option :label="$t('productGroupManage.enable')" value="1001" />
          <el-option :label="$t('productGroupManage.disable')" value="2002" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('productGroupManage.startTime')">
        <el-date-picker v-model="addProductGroupInfo.startTime" type="datetime"
        value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('productGroupManage.startTimeRequired')" style="width:100%" />
      </el-form-item>

      <el-form-item :label="$t('productGroupManage.endTime')">
        <el-date-picker v-model="addProductGroupInfo.endTime" type="datetime"
        value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('productGroupManage.endTimeRequired')" style="width:100%" />
      </el-form-item>

      <el-form-item :label="$t('productGroupManage.isRebate')">
        <el-select v-model="addProductGroupInfo.rebateFlag" :placeholder="$t('productGroupManage.isRebateRequired')"
          style="width:100%">
          <el-option disabled :value="''" :label="$t('productGroupManage.isRebateRequired')" />
          <el-option :label="$t('productGroupManage.yes')" value="Y" />
          <el-option :label="$t('productGroupManage.no')" value="N" />
        </el-select>
      </el-form-item>

      <el-form-item v-if="addProductGroupInfo.rebateFlag === 'Y'" :label="$t('productGroupManage.leaderRebate')">
        <el-row :gutter="20">
          <el-col :span="4">
            <span>{{ $t('productGroupManage.commercialPrice') }}</span>
          </el-col>
          <el-col :span="4">
            <el-input v-model="addProductGroupInfo.rebate" type="number"
              :placeholder="$t('productGroupManage.rebateNumber')" />
          </el-col>
          <el-col :span="4">
            <span>% {{ $t('productGroupManage.rebate') }}</span>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveProductGroupInfo">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveProductGroup } from '@/api/group/productGroupApi'
import { queryProductCategory, queryProduct } from '@/api/goods/productApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddProductGroup',
  data() {
    return {
      dialogVisible: false,
      addProductGroupInfo: {
        categoryId: '',
        productId: '',
        valueId: '',
        prodDesc: '',
        userCount: '',
        groupPrice: '',
        state: '',
        startTime: '',
        endTime: '',
        rebateFlag: '',
        rebate: '',
        productCategorys: [],
        products: [],
        values: []
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this._listAddProductCategorys()
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.addProductGroupInfo = {
        categoryId: '',
        productId: '',
        valueId: '',
        prodDesc: '',
        userCount: '',
        groupPrice: '',
        state: '',
        startTime: '',
        endTime: '',
        rebateFlag: '',
        rebate: '',
        productCategorys: [],
        products: [],
        values: []
      }
    },
    async _listAddProductCategorys() {
      try {
        const res = await queryProductCategory({
          page: 1,
          row: 100,
          shopId: getShopId()
        })
        this.addProductGroupInfo.productCategorys = res.data
      } catch (error) {
        console.error(error)
      }
    },
    async _changeAddProductCatalorys() {
      try {
        const res = await queryProduct({
          page: 1,
          row: 100,
          shopId: getShopId(),
          categoryId: this.addProductGroupInfo.categoryId
        })
        this.addProductGroupInfo.products = res.data
      } catch (error) {
        console.error(error)
      }
    },
    async _changeAddProduct() {
      try {
        const res = await queryProduct({
          page: 1,
          row: 1,
          shopId: getShopId(),
          productId: this.addProductGroupInfo.productId
        })
        this.addProductGroupInfo.values = res.data[0].productSpecValues
        this.addProductGroupInfo.prodDesc = res.data[0].prodDesc
      } catch (error) {
        console.error(error)
      }
    },
    _getValueSpecName(value) {
      let specName = ''
      value.productSpecDetails.forEach(item => {
        specName += (item.detailValue + ';')
      })
      return specName
    },
    async saveProductGroupInfo() {
      try {
        this.addProductGroupInfo.shopId = getShopId()
        await saveProductGroup(this.addProductGroupInfo)
        this.$message.success(this.$t('common.saveSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        this.$message.error(error)
        console.error(error)
      }
    }
  }
}
</script>